import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserListModel } from '../user-list.model';

@Injectable()
export class UserListService {
	endpointBase = '/api/user';

	constructor(private readonly http: HttpClient) {}

	getUsers(accountId: number): Observable<UserListModel[]> {
		return this.http.get<UserListModel[]>(`${this.endpointBase}/search-by-account/${accountId}`);
	}

	assignAccount(accountId: number, users: UserListModel[]): Observable<any> {
		return this.http.post(`${this.endpointBase}/assign-account/${accountId}`, users);
	}
}
